import React from 'react';

const FacebookOutlinedBlue = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10.667"
        height="16"
        viewBox="0 0 10.667 16"
        fill="none"
    >
        <path
            d="M3.893 1.729A4.08 4.08 0 0 1 6.779.533H8.81a.7.7 0 0 1 .7.7V3.94c0 .387-.315.7-.701.7H6.804v1.307h2.007a.7.7 0 0 1 .68.869l-.677 2.707a.7.7 0 0 1-.679.531H6.806v4.713c0 .387-.315.7-.701.7H3.398a.7.7 0 0 1-.7-.7v-4.713H1.369a.7.7 0 0 1-.702-.7V6.647a.7.7 0 0 1 .7-.7h1.331V4.616c0-1.083.429-2.12 1.195-2.887m2.887.204a2.68 2.68 0 0 0-2.684 2.683v2.031a.7.7 0 0 1-.7.7H2.067v1.307h1.329a.7.7 0 0 1 .7.7v4.713h1.307V9.354c0-.387.315-.7.701-.7h1.483l.327-1.307h-1.81a.7.7 0 0 1-.701-.7V4.616A1.377 1.377 0 0 1 6.782 3.24h1.329V1.933z"
            fill="#009FDF"
        />
    </svg>
);
export default FacebookOutlinedBlue;
